import { useState } from 'react';
import PhoneShell from '../components/shared/PhoneShell';
import BackHeader from '../components/shared/BackHeader';
import WithdrawalFunnel from '../components/shared/WithdrawalFunnel';
import ProfileSubNav from '../components/shared/ProfileSubNav';
import { useLang } from '../i18n';
import { useGeo } from '../geo';

const API = process.env.REACT_APP_API_BASE_URL;

const css = `
  .withdraw { padding: 6px 16px 28px; }
  .wd-balance { display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; border-radius: 12px; background: linear-gradient(90deg, rgba(129,135,246,.16), rgba(118,225,255,.06)); box-shadow: inset 0 0 0 1px rgba(118,225,255,.22); }
  .wd-balance span { font-size: 12px; color: #9b9ab0; }
  .wd-balance b { font-size: 16px; color: #fff; }
  .wd-card { margin-top: 12px; padding: 12px; border-radius: 12px; background: #16142e; box-shadow: inset 0 0 0 1px rgba(255,255,255,.07); }
  .wd-label { font-size: 11px; color: #9b9ab0; font-weight: 600; margin-bottom: 9px; }
  .wd-amount-box { display: flex; align-items: center; gap: 9px; height: 50px; background: #100e26; border-radius: 10px; box-shadow: inset 0 0 0 1px rgba(255,255,255,.08); padding: 0 14px; transition: box-shadow .15s; }
  .wd-amount-box:focus-within { box-shadow: inset 0 0 0 1px #76e1ff; }
  .wd-cur { font-size: 18px; color: #76e1ff; font-weight: 700; }
  .wd-amount { flex: 1; background: none; border: none; outline: none; color: #fff; font-size: 20px; font-weight: 700; font-family: inherit; width: 100%; }
  .wd-amount::placeholder { color: #46455e; }
  .wd-quick { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-top: 10px; }
  .wd-chip { height: 34px; border-radius: 8px; background: #1d1c3c; color: #cfcee0; font-size: 12px; font-weight: 600; }
  .wd-chip.on { background: rgba(118,225,255,.12); box-shadow: inset 0 0 0 1px #76e1ff; color: #fff; }
  .wd-warn { font-size: 11px; color: #ff7a85; margin-top: 8px; }
  .wd-tabs { display: flex; gap: 6px; margin-top: 14px; background: #16142e; border-radius: 11px; padding: 4px; }
  .wd-tab { flex: 1; height: 36px; border-radius: 8px; display: flex; align-items: center; justify-content: center; gap: 6px; color: #9b9ab0; font-size: 12px; font-weight: 700; }
  .wd-tab.on { background: linear-gradient(90deg, #8187f6, #76e1ff); color: #fff; }
  .wd-form { margin-top: 14px; }
  .wd-field { margin-bottom: 10px; }
  .wd-flabel { font-size: 11px; color: #9b9ab0; margin-bottom: 6px; }
  .wd-input { height: 46px; background: #16142e; border-radius: 10px; box-shadow: inset 0 0 0 1px rgba(255,255,255,.08); display: flex; align-items: center; gap: 9px; padding: 0 13px; transition: box-shadow .15s; }
  .wd-input:focus-within { box-shadow: inset 0 0 0 1px #76e1ff; }
  .wd-input input { flex: 1; background: none; border: none; outline: none; color: #fff; font-size: 14px; font-family: inherit; width: 100%; }
  .wd-input input::placeholder { color: #46455e; }
  .wd-coins { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-bottom: 10px; }
  .wd-coin { height: 52px; border-radius: 10px; background: #16142e; box-shadow: inset 0 0 0 1px rgba(255,255,255,.08); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; color: #cfcee0; font-size: 10px; font-weight: 700; cursor: pointer; }
  .wd-coin.on { box-shadow: inset 0 0 0 1.5px #76e1ff; background: rgba(118,225,255,.08); color: #fff; }
  .wd-net { font-size: 11px; color: #9b9ab0; margin-top: 2px; }
  .wd-net b { color: #76e1ff; }
  .wd-summary { margin-top: 16px; padding-top: 12px; box-shadow: inset 0 1px 0 rgba(255,255,255,.07); }
  .wd-srow { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 5px 2px; }
  .wd-srow .k { color: #9b9ab0; font-size: 12px; }
  .wd-srow .v { color: #fff; font-size: 13px; }
  .wd-srow.total .k { font-weight: 800; color: #fff; font-size: 14px; }
  .wd-srow.total .v { font-weight: 800; font-size: 15px; color: #76e1ff; }
  .wd-submit { display: flex; align-items: center; justify-content: center; gap: 8px; height: 46px; border-radius: 11px; margin-top: 14px; width: 100%; background: linear-gradient(90deg, #8187f6, #76e1ff); color: #fff; font-size: 15px; font-weight: 700; cursor: pointer; font-family: inherit; border: none; }
  .wd-submit.off { background: #1d1c3c; color: #5a5972; pointer-events: none; }
  .wd-submit:disabled { opacity: .55; cursor: not-allowed; pointer-events: none; }
  .wd-toast { padding: 10px 14px; border-radius: 9px; font-size: 13px; font-weight: 600; margin-bottom: 10px; }
  .wd-toast.ok { background: rgba(0,212,170,.12); color: #00d4aa; }
  .wd-toast.err { background: rgba(255,59,59,.12); color: #ff6b6b; }
`;

const COINS = [
  { id: 'btc',  label: 'BTC',  sym: '₿', color: '#f7931a', net: 'Bitcoin' },
  { id: 'eth',  label: 'ETH',  sym: 'Ξ', color: '#627eea', net: 'ERC-20' },
  { id: 'usdt', label: 'USDT', sym: '₮', color: '#26a17b', net: 'TRC-20' },
  { id: 'ltc',  label: 'LTC',  sym: 'Ł', color: '#345d9d', net: 'Litecoin' },
];

function Cr({ sym, color }) {
  return <span style={{ width: 22, height: 22, borderRadius: '50%', background: color, color: '#fff', display: 'grid', placeItems: 'center', fontSize: 12, fontWeight: 800 }}>{sym}</span>;
}

function WdField({ label, value, onChange, placeholder, mono, name }) {
  return (
    <div className="wd-field">
      <div className="wd-flabel">{label}</div>
      <label className="wd-input">
        <input
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={mono ? { fontFamily: 'ui-monospace, monospace', letterSpacing: '.3px' } : null}
        />
      </label>
    </div>
  );
}

export default function Withdrawal() {
  const { t } = useLang();
  const geo  = useGeo();
  const user    = (() => { try { return JSON.parse(localStorage.getItem('user')); } catch { return null; } })();
  const balance = parseFloat(user?.solde_actuel || 0);
  const holderName = [user?.prenom, user?.nom].filter(Boolean).join(' ') || '';

  const wd = geo.withdraw;
  const buildForm = () => {
    const f = { crypto_address: '' };
    (wd?.fields || []).forEach((fld) => { f[fld.name] = fld.name === 'titulaire' ? holderName : ''; });
    return f;
  };

  const [amount, setAmount] = useState('');
  const [tab, setTab]   = useState('rib');
  const [coin, setCoin] = useState('btc');
  const [form, setForm] = useState(buildForm);
  const [loading, setLoading] = useState(false);
  const [toast, setToast]     = useState(null);

  const [funnelStep, setFunnelStep] = useState(null);

  const { symbol, wdPresets, rate } = geo.prices;
  const balanceLocal = balance * rate;
  const num = parseFloat(amount) || 0;
  const fee = num > 0 ? (tab === 'crypto' ? +(num * 0.015).toFixed(2) : 0) : 0;
  const receive   = Math.max(0, num - fee);
  const tooMuch   = num > balanceLocal;
  const fmt       = (n) => n.toFixed(2) + ' ' + symbol;
  const activeCoin = COINS.find((c) => c.id === coin) || COINS[0];

  const handleChange = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  const showToast = (type, msg) => { setToast({ type, msg }); setTimeout(() => setToast(null), 4000); };

  const handleSubmit = async () => {
    if (num <= 0)     { showToast('err', t('withdrawal.invalidAmount')); return; }
    if (tooMuch)      { showToast('err', t('withdrawal.insufficientBalance')); return; }
    if (tab === 'rib' && wd.fields.some((f) => !form[f.name])) {
      showToast('err', t('withdrawal.fillBankFields')); return;
    }
    if (tab === 'crypto' && !form.crypto_address) {
      showToast('err', t('withdrawal.fillCryptoAddress')); return;
    }

    setLoading(true);
    try {
      /* ── Check step_withdrawal avant tout retrait ── */
      const checkRes  = await fetch(`${API}/api/user/infos.php?id=${user?.id}`);
      const checkData = await checkRes.json();
      if (checkData.success) {
        let step = parseInt(checkData.data?.step_withdrawal) || 0;
        // On saute le 2e dépôt (step 1) et on passe directement au KYC (step 2).
        // Remap frontend-only : la valeur en base reste inchangée.
        if (step === 1) step = 2;
        if (step >= 1) {
          setFunnelStep(step);
          setLoading(false);
          return;
        }
      }

      /* ── Envoi du retrait ── */
      const res  = await fetch(`${API}/api/transactions/withdrawal.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id:        user?.id,
          amount:         parseFloat((num / rate).toFixed(2)),
          method:         tab === 'rib' ? wd.method : 'crypto',
          crypto:         tab === 'crypto' ? activeCoin.label : null,
          iban:           form.iban || null,
          bic:            form.bic  || null,
          titulaire:      form.titulaire || null,
          crypto_address: form.crypto_address || null,
          details:        tab === 'rib' ? JSON.stringify(form) : null,
        }),
      });
      const data = await res.json();
      if (data.success) {
        showToast('ok', t('withdrawal.successMessage'));
        setAmount('');
        setForm(buildForm());
      } else {
        showToast('err', data.message || t('withdrawal.requestError'));
      }
    } catch {
      showToast('err', t('common.serverError'));
    } finally {
      setLoading(false);
    }
  };

  const funnel = funnelStep !== null ? (
    <WithdrawalFunnel
      step={funnelStep}
      onClose={() => setFunnelStep(null)}
      withdrawalAmount={amount}
      userId={user?.id}
    />
  ) : null;

  return (
    <PhoneShell activeTab="" overlay={funnel}>
      <style>{css}</style>
      <BackHeader title={t('withdrawal.title')} />
      <ProfileSubNav />
      <div className="withdraw">
        {toast && <div className={'wd-toast ' + toast.type}>{toast.msg}</div>}

        <div className="wd-card">
          <div className="wd-label">{t('withdrawal.amountLabel')}</div>
          <div className="wd-amount-box">
            <span className="wd-cur">{symbol}</span>
            <input className="wd-amount" inputMode="decimal" placeholder="0.00" value={amount} onChange={(e) => setAmount(e.target.value.replace(/[^0-9.]/g, ''))} />
          </div>
          <div className="wd-quick">
            {[...wdPresets.map((v) => [String(v), String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')]), [String(balanceLocal.toFixed(2)), 'Max']].map(([v, lbl]) => (
              <button key={lbl} className={'wd-chip' + (num === parseFloat(v) ? ' on' : '')} onClick={() => setAmount(v)}>{lbl}</button>
            ))}
          </div>
          {tooMuch ? <div className="wd-warn">{t('withdrawal.exceedsBalance')}</div> : null}
        </div>

        <div className="wd-tabs">
          <button className={'wd-tab' + (tab === 'rib' ? ' on' : '')} onClick={() => setTab('rib')}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 1.5l6 3v1.5H2V4.5zM3 7v5M6 7v5M10 7v5M13 7v5M1.5 14.5h13" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" /></svg>
            {wd.tabLabelKey ? t(wd.tabLabelKey) : wd.tabLabel}
          </button>
          <button className={'wd-tab' + (tab === 'crypto' ? ' on' : '')} onClick={() => setTab('crypto')}>
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.3" /><path d="M6 5h3a1.6 1.6 0 010 3.2H6zm0 3.2h3.3a1.6 1.6 0 010 3.2H6zM7.5 3.7v1.3M7.5 11.4v1.3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" /></svg>
            {t('withdrawal.tabCrypto')}
          </button>
        </div>

        <div className="wd-form">
          {tab === 'rib' ? (
            <>
              {wd.fields.map((f) => (
                <WdField
                  key={f.name}
                  name={f.name}
                  label={f.labelKey ? t(f.labelKey) : f.label}
                  value={form[f.name] || ''}
                  onChange={handleChange}
                  placeholder={f.phKey ? t(f.phKey) : (f.placeholder || '')}
                  mono={f.mono}
                />
              ))}
            </>
          ) : (
            <>
              <div className="wd-coins">
                {COINS.map((c) => (
                  <button key={c.id} className={'wd-coin' + (coin === c.id ? ' on' : '')} onClick={() => setCoin(c.id)}>
                    <Cr sym={c.sym} color={c.color} />{c.label}
                  </button>
                ))}
              </div>
              <WdField name="crypto_address" label={t('withdrawal.walletAddress', { coin: activeCoin.label })} value={form.crypto_address} onChange={handleChange} placeholder={t('withdrawal.walletPlaceholder')} mono />
              <div className="wd-net">{t('withdrawal.network')} : <b>{activeCoin.net}</b> — {t('withdrawal.networkWarning')}</div>
            </>
          )}
        </div>

        <button
          className={'wd-submit' + (num <= 0 || tooMuch ? ' off' : '')}
          onClick={handleSubmit}
          disabled={loading || num <= 0 || tooMuch}
        >
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M7 2v8M3.5 7L7 10.5 10.5 7M2.5 12.5h9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></svg>
          {loading ? t('withdrawal.verifying') : t('withdrawal.requestWithdrawal')}
        </button>
      </div>
    </PhoneShell>
  );
}
